module.exports = __webpack_public_path__ + "assets/img/客户墙.f1faa2de.jpg";